import { action } from 'typesafe-actions';
import { NewLongSteelOrdersOnboardingTypes } from './types';

export const startOnboarding = () =>
  action(NewLongSteelOrdersOnboardingTypes.START);
export const nextOnboardingStep = () =>
  action(NewLongSteelOrdersOnboardingTypes.NEXT_STEP);
export const finishOnboarding = () =>
  action(NewLongSteelOrdersOnboardingTypes.FINISHED);
